import React, { useCallback, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button, MenuSection } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { fetchPublisherById } from "../../api/publisherService";
import PublisherDetail from "../../components/publisher/PublisherDetail";
import { ReminderSettingsDialog } from "../../components/publisher/ReminderSettingsDialog";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { PublisherOwnerEnum } from "../../types/Api";
import { ROUTE_PATHS } from "../../types/routePaths";
import { usePermissions } from "../../hooks/usePermissions";
var PublisherDetailPage = function () {
    var _a;
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var canEditPublisherItem = usePermissions().canEditPublisherItem;
    var _b = useState(false), reminderDialogOpen = _b[0], setReminderDialogOpen = _b[1];
    var _c = useQuery(["publisher", id], function () { return fetchPublisherById(ky, id); }, {
        enabled: !!id,
    }), publisher = _c.data, isLoading = _c.isLoading, isError = _c.isError, error = _c.error;
    var handleBackToList = useCallback(function () { return history.goBack(); }, [history]);
    var handleCloseReminderDialog = useCallback(function () { return setReminderDialogOpen(false); }, []);
    if (!id) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.publishers.detail.pane.title",
                }) },
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.error.id.not.provided" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })))));
    }
    if (isLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.publishers.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.loading" }))));
    }
    if (isError || !publisher) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.publishers.detail.pane.title",
                }) },
                React.createElement("p", null, (error === null || error === void 0 ? void 0 : error.message) || (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.error.publisher.not.found" }))),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })))));
    }
    var displayName = publisher.name ||
        formatMessage({ id: "ui-br-legaldeposits.publishers.detail.pane.title" });
    var publisherContacts = (_a = publisher.contacts) !== null && _a !== void 0 ? _a : [];
    var actionMenu = function () { return (React.createElement(MenuSection, { label: formatMessage({
            id: "ui-br-legaldeposits.action.menu.label",
        }), id: "actions-menu" },
        canEditPublisherItem && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                history.push("".concat(ROUTE_PATHS.PUBLISHERS, "/edit/").concat(id));
            }, fullWidth: true },
            React.createElement(FormattedMessage, { id: publisher.owner === PublisherOwnerEnum.PUBLISHERS
                    ? "ui-br-legaldeposits.publishers.detail.action.editContacts"
                    : "ui-br-legaldeposits.publishers.detail.action.edit" }))),
        canEditPublisherItem && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () { return setReminderDialogOpen(true); }, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.reminderSettings.title" }))))); };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: displayName, firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })), actionMenu: actionMenu },
            React.createElement(PublisherDetail, { publisher: publisher })),
        reminderDialogOpen && (React.createElement(ReminderSettingsDialog, { open: true, onClose: handleCloseReminderDialog, publisherId: id, contacts: publisherContacts }))));
};
export default PublisherDetailPage;
